export default __webpack_public_path__ + "static/3-320afcbdaeff93f3b7cc6f3e684d3ea3.jpg";